<vwui-form-group class="filter-input__group" [formGroup]="optionsControl">
  @for (control of optionsControl.controls | keyvalue; track control) {
    @if (optionsControl.get(control.key)) {
      <div [formGroupName]="control.key">
        <vwui-checkbox formControlName="selected">
          {{ optionsControl.get(control.key).value.name }}
        </vwui-checkbox>
      </div>
    }
  }
</vwui-form-group>
